import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { importRemote } from '@module-federation/utilities';
import { getShopperId } from '../../../util/auth';
import useSiteData from '../../../hooks/useSiteData';
import useIdentityContext from '../../../hooks/useIdentityContext';
import { LineItemReorderActionStatusContext } from '../../contexts/LineItemReorderActionStatusContext';
import { ExpressCheckoutContext } from '../../contexts/ExpressCheckoutContext';
import { DYNAMIC_EXPRESS_CHECKOUT } from '../../../constants/moduleFederation';

export const DynamicExpressCheckout = ({
  cartDetails,
  showExpressCheckoutFlyout,
  setShowExpressCheckoutFlyout,
  pageDetails,
}) => {
  const shopperId = getShopperId();
  const { locale } = useSiteData();
  const { auth } = useIdentityContext();
  const { cartTenantDetails } = useContext(ExpressCheckoutContext);
  const { setGenericFailure } = useContext(LineItemReorderActionStatusContext);

  const ExpressCheckout = React.lazy(() =>
    importRemote({
      url: DYNAMIC_EXPRESS_CHECKOUT.url,
      scope: DYNAMIC_EXPRESS_CHECKOUT.scope,
      module: DYNAMIC_EXPRESS_CHECKOUT.module,
      remoteEntryFileName: DYNAMIC_EXPRESS_CHECKOUT.fileName,
      bustRemoteEntryCache: false,
    }).catch(() => {
      setGenericFailure(true);
      return { default: () => null };
    })
  );

  if (
    !ExpressCheckout ||
    !cartTenantDetails ||
    Object.keys(cartTenantDetails).length === 0
  ) {
    return null;
  }

  return (
    <div>
      <React.Suspense fallback={null}>
        <ExpressCheckout
          showExpressCheckout={showExpressCheckoutFlyout}
          setShowExpressCheckout={setShowExpressCheckoutFlyout}
          shopperId={shopperId}
          locale={locale}
          auth={auth}
          pageDetails={pageDetails}
          tenantDetails={cartTenantDetails}
          cartDetails={cartDetails}
        />
      </React.Suspense>
    </div>
  );
};

DynamicExpressCheckout.propTypes = {
  cartDetails: PropTypes.shape({
    type: PropTypes.string,
    altCartId: PropTypes.string,
  }),
  showExpressCheckoutFlyout: PropTypes.bool.isRequired,
  setShowExpressCheckoutFlyout: PropTypes.func.isRequired,
  pageDetails: PropTypes.shape({
    pageName: PropTypes.string,
    pageSection: PropTypes.string,
    pageStage: PropTypes.string,
  }),
};
